import React from 'react';
import Row from '../layout/Row';
import Icon from '../icon/index';
import {strings} from '../../util/strings';
import Column from '../layout/Column';
import {Icons} from '../../util/icons';
import {colors} from '../../util/colors';
import * as fonts from '../../../src/util/fonts';
import AppDownloadButton from '../app-download-button/AppDownloadButton';
import {compose} from 'redux';
import {connect} from 'react-redux';
import attachfiles from '../../assets/attach-files.svg';

export interface RenderDocumentProps {
  item: any;
  documentDownload(value: any): void;
  labelsIrs: typeof strings.pt.IRS;
  buStyles: any;
  isIrsDeclaration: any;
}

function RenderDocument({
  item,
  documentDownload,
  labelsIrs,
  buStyles,
  isIrsDeclaration,
}: RenderDocumentProps) {
  return (
    <a
      target="_blank"
      onClick={() => {
        documentDownload(item);
      }}
      className={isIrsDeclaration ? 'anchor-irs m-0' : 'anchor m-0'}>
      <Row className="reimbursement-success-file">
        {!isIrsDeclaration && (
          <Icon
            className="reimbursement-success-file-icon"
            style={{margin: '1rem'}}
            name={Icons.DECLARATIONS}
            width={'26'}
            height={'26'}
            changeViewbox
            viewBox={'0 0 24 24'}
          />
        )}
        {isIrsDeclaration && (
          <img className="irs-declaration-icon" src={attachfiles} />
        )}
        <Column
          className="reimbursement-success-file-title"
          style={{...fonts.M, ...fonts.Medium}}>
          {item.description ||
            item.path ||
            `${labelsIrs.IRS_documentTitle} ${' '} ${item.year}`}
        </Column>
        <AppDownloadButton color={buStyles?.primaryColor || colors.blue} />
      </Row>
    </a>
  );
}

const mapStateToProps = ({strings, globalStyles}: any) => ({
  labelsIrs: strings.value.pt.IRS,
  buStyles: globalStyles.value,
});

export default compose(connect(mapStateToProps)(RenderDocument));
